// DEV-5108: rspack's DefinePlugin only substitutes LITERAL `process.env.KEY` member-expressions and
// never defines a bare `process` object, so the previous `process.env[key]` (computed key) behind a
// `typeof process !== 'undefined'` guard resolved to undefined for EVERY key in the browser bundle —
// silently discarding all `.env` API-base overrides and always using the hardcoded defaults. Each entry
// below is a literal access DefinePlugin can substitute at build time; every key here must also be seeded
// in config/env.ts so it is defined (an undefined-and-unsubstituted `process.env.X` would ReferenceError).
const ENV_VARIABLES: Record<string, string | undefined> = {
  NODE_ENV: process.env.NODE_ENV,
  TPO_API_URL: process.env.TPO_API_URL,
  TPO_ACCOUNTS_API_BASE_URL: process.env.TPO_ACCOUNTS_API_BASE_URL,
  TPO_SIGNING_API_BASE_URL: process.env.TPO_SIGNING_API_BASE_URL,
  ADMIN_PANEL_URL: process.env.ADMIN_PANEL_URL,
  TPO_IFRAME_PARENT_ORIGINS: process.env.TPO_IFRAME_PARENT_ORIGINS,
  TPO_PDFJS_STANDARD_FONTS_URL: process.env.TPO_PDFJS_STANDARD_FONTS_URL,
};

// The release image is built once and promoted through every environment, so a build-time value
// cannot be right for all of them — prod used to fall through to the hardcoded dev API defaults.
// Per-environment values are rendered into window.tpoRuntimeEnv by the Express server from the App
// Service settings; an unrendered '{{ KEY }}' (rspack dev server) or empty value means "not set".
declare global {
  interface Window {
    tpoRuntimeEnv?: Record<string, string | undefined>;
  }
}

const RUNTIME_KEYS = [
  'TPO_API_URL',
  'TPO_ACCOUNTS_API_BASE_URL',
  'TPO_SIGNING_API_BASE_URL',
  'ADMIN_PANEL_URL',
  'TPO_IFRAME_PARENT_ORIGINS',
];

function getRuntimeVariable(key: string): string | undefined {
  if (!RUNTIME_KEYS.includes(key) || typeof window === 'undefined') {
    return undefined;
  }

  const value = window.tpoRuntimeEnv?.[key]?.trim();
  if (!value || value.startsWith('{{')) {
    return undefined;
  }

  return value;
}

export function getEnvVariable(key: string): string | undefined {
  const runtimeValue = getRuntimeVariable(key);
  if (runtimeValue) {
    return runtimeValue;
  }

  // The two lists (this map + the config/env.ts DefinePlugin seed) must stay in lockstep, and a
  // one-sided addition is invisible to lint/jest: a key missing HERE silently returns undefined
  // (override ignored), a key missing from the SEED ReferenceErrors at runtime. Surface a missing key
  // loudly in dev so the next editor keeps both sides in sync rather than shipping a silent regression.
  if (process.env.NODE_ENV !== 'production' && !(key in ENV_VARIABLES)) {
    console.warn(
      `getEnvVariable: '${key}' is not in ENV_VARIABLES — add it here AND seed it in config/env.ts.`,
    );
  }

  return ENV_VARIABLES[key];
}
